// Shared grouping for movement lists. `MovementsList` (Categories + Accounts
// detail panels) uses 'month'; `DashboardIncompleteMovements` uses 'day' with
// contextual labels (TODAY/YESTERDAY/weekday).
//
// Both strategies return an ordered array of { key, label, items } groups.
// `key` is React-stable (used as map key); `label` is the display heading.
import { monthShort, monthShortUpper, dayShortUpper, labelToday, labelYesterday } from './intlFormatters';

function groupByMonth(movements) {
  const grouped = {};
  movements.forEach(m => {
    const d = new Date(m.date + 'T00:00:00');
    const key = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
    const label = `${monthShort(d.getMonth())} ${d.getFullYear()}`;
    if (!grouped[key]) grouped[key] = { key, label, items: [] };
    grouped[key].items.push(m);
  });
  // Newest-first — keys are YYYY-MM, so alphabetical reverse is chronological reverse.
  return Object.keys(grouped).sort().reverse().map(k => grouped[k]);
}

function groupByDay(movements) {
  const groups = {};
  const order = [];
  const today = new Date().toISOString().split('T')[0];
  const yesterday = new Date(Date.now() - 86400000).toISOString().split('T')[0];
  for (const m of movements) {
    let label;
    if (m.date === today) label = labelToday();
    else if (m.date === yesterday) label = labelYesterday();
    else {
      // Noon avoids DST edge cases when converting a YYYY-MM-DD string to a Date.
      const d = new Date(m.date + 'T12:00:00');
      const weekday = dayShortUpper(d.getDay());
      const month = monthShortUpper(d.getMonth());
      const day = d.getDate();
      label = `${weekday}, ${month} ${day}`;
    }
    if (!groups[label]) { groups[label] = { key: label, label, items: [] }; order.push(label); }
    groups[label].items.push(m);
  }
  // Preserve input order — callers pre-sort by date.
  return order.map(label => groups[label]);
}

export function groupMovementsByDate(movements, strategy = 'month') {
  const list = movements || [];
  return strategy === 'day' ? groupByDay(list) : groupByMonth(list);
}
